const ALL_TABS = [
  { title: 'Full Portfolio', role: 'vp' },
  { title: 'Multi-Site', role: 'rm' },
  { title: 'Property Manager', role: 'pm' },
];

/** Tabs available on Delegation > Invite, based on logged-in user role. */
export function getDelegationInviteTabs(userRole) {
  switch (userRole) {
    case 'll':
      return ALL_TABS;
    case 'vp':
      return ALL_TABS.filter((tab) => tab.role !== 'vp');
    default:
      // Property Manager / Multi-Site cannot send invitations.
      return [];
  }
}

export function isDelegationInviteSingleSelect(inviteRole) {
  return inviteRole === 'pm';
}

export function filterDelegationInviteBuildings(buildings, inviteRole) {
  if (!Array.isArray(buildings)) return [];
  if (inviteRole !== 'pm') return buildings;
  return buildings.filter((building) => {
    const dispositioned = building?.dispositioned;
    if (dispositioned === true || dispositioned === 'true') return false;
    return true;
  });
}
